<template>
  <div>
    <van-tabs class="custom" style="overflow: visible">
      <van-tab title="团队赞助">
        <sponsor-team :list="teams" :sponsor="teamsSponsor" />
      </van-tab>
      <van-tab title="企业赞助">
        <sponsor-company :list="companys" :sponsor="companysSponsor" />
      </van-tab>
      <van-tab title="个人赞助">
        <sponsor-person :list="persons" :sponsor="personsSponsor" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import SponsorTeam from './SponsorTeam'
import SponsorCompany from './SponsorCompany'
import SponsorPerson from './SponsorPerson'

export default {
  components: {
    SponsorTeam,
    SponsorCompany,
    SponsorPerson
  },
  props: {
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    sponsor() {
      return this.detail.sponsor || {}
    },
    teams() {
      return (this.sponsor.group || []).slice(0, 4)
    },
    teamsSponsor() {
      return (this.sponsor.group || []).slice(0, 4)
    },
    companys() {
      return (this.sponsor.company || []).slice(0, 4)
    },
    companysSponsor() {
      return (this.sponsor.company || []).slice(0, 4)
    },
    persons() {
      return (this.sponsor.personal || []).slice(0, 4)
    },
    personsSponsor() {
      return (this.sponsor.personal || []).slice(0, 4)
    }
  }
}
</script>
